module.exports = __webpack_public_path__ + "media/images/embolt-3f78ffae935716777dfa067c13248a75.svg";